var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('v-dialog',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('p',[_vm._v("This is a modal!")]),_c('button',{on:{"click":_vm.closeModal}},[_vm._v("Close")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }